import solutions from "@/content/solutions.json";
import caseStudies from "@/content/case-studies.json";

export function getSolutionById(id) {
  return solutions.find((s) => s.id === id);
}

export function getAllSolutions() {
  return solutions;
}

export function getCaseStudyById(id) {
  return caseStudies.find((c) => c.id === id);
}

export function getAllCaseStudies() {
  return caseStudies;
}

export function getCaseStudyForSolution(solutionId) {
  return caseStudies.find((c) => c.relatedSolution === solutionId);
}
